define('all/bonusslider',['jquery'], function($) {
	'use strict';
	$.fn.bonusSlider = function(options) {

		// default configuration properties
		var defaults = {
			speed: 800,
			pause: 2000
		};

		options = $.extend(defaults, options);

		this.each(function() {
			var $sliderBg = $('#slider-bg');
			var $sliderText = $('#slider-text');

			var s = $('li', $sliderBg).length;
			var w = $('li', $sliderBg).width();
			var h = $('li', $sliderBg).height();

			var clickable = true;
			$('#slider', $sliderBg).width(w);
			$('#slider', $sliderBg).height(h);

			var ts = s - 1;
			var t = 0;
			$('ul', $sliderBg).css('width', s * w);

			//If there are more than 3 bonuses, prepare for looping and highlight the middle bonus icon, else highlight the one to the left.
			if (s > 3) {
				//Clone and add bonuses to the begining and the end to make a seamless loop. If you want to see how it works remove overflow: hidden; from div#slider-bg in the css
				$('ul', $sliderBg).prepend($('ul li:last-child', $sliderBg).clone());
				$('ul', $sliderBg).prepend($('ul li:nth-child(' + (s) + ')', $sliderBg).clone().css('margin-left', '-' + w + 'px'));
				$('ul', $sliderBg).append($('ul li:nth-child(3)', $sliderBg).clone());
				$('ul', $sliderBg).append($('ul li:nth-child(4)', $sliderBg).clone());
				$('ul', $sliderBg).append($('ul li:nth-child(5)', $sliderBg).clone());
				$('ul', $sliderBg).css('width', (s + 4) * w);

				//Make the middle bonus (first <li>) selected and populate the info section with the correct info
				$('ul li:nth-child(3)', $sliderBg).css('opacity', '1');
				$('> h3', $sliderText).replaceWith($('ul li:nth-child(3) > h3', $sliderBg).clone());
				$('> p', $sliderText).replaceWith($('ul li:nth-child(3) > p', $sliderBg).clone());
				$('> p', $sliderText).ellipsis(true);
				$('> a', $sliderText).replaceWith($('ul li:nth-child(3) > a.bonus-button', $sliderBg).clone().show());

				//Show next and previous controls
				$($sliderBg).after(' <a id="prevBtn" href="javascript:"><span></span></a>');
				$($sliderBg).before(' <a id="nextBtn" href="javascript:"><span></span></a>');

				// Add the click function to the next and previous controls
				$('#nextBtn').click(function () {
					animate('next', true);
				});
				$('#prevBtn').click(function () {
					animate('prev', true);
				});

				//Add click functions to the bonuses next to the middle one.
				$('ul li:nth-child(4)', $sliderBg).click(function () {
					animate('next', true);
				});

				$('ul li:nth-child(2)', $sliderBg).click(function () {
					animate('prev', true);
				});

			} else {

				$('ul li', $sliderBg).click(
					function() {
						var $this = $(this);
						$('ul li', $sliderBg).css('opacity', '0.4');
						$this.css('opacity', '1');
						$('> h3', $sliderText).replaceWith($('> h3', this).clone());
						$('> p', $sliderText).replaceWith($('> p', this).clone());
						$('> p', $sliderText).ellipsis(true);
						$('> a', $sliderText).replaceWith($('> a.bonus-button', this).clone().show());
					}
				);

				//Just sets focus on the first from the list
				$('ul li:first-child', $sliderBg).trigger('click');
			}

			// After animation this function populates the info section with the correct info, makes the centerded bonus selected and removes and adds click functions to the bonuses next to the middle one.
			function setCurrent(i) {
				i = parseInt(i, 10) + 1;

				//Replace the info section with new content
				$('> h3', $sliderText).replaceWith($('ul li:nth-child(' + (i + 2) + ') > h3', $sliderBg).clone());
				$('> p', $sliderText).replaceWith($('ul li:nth-child(' + (i + 2) + ') > p', $sliderBg).clone())
				$('> p', $sliderText).ellipsis(true);
				$('> a', $sliderText).replaceWith($('ul li:nth-child(' + (i + 2) + ') > a.bonus-button', $sliderBg).clone().show());

				//Change all bonuses opacity and after that highlight the middle one.
				$('ul li', $sliderBg).css('opacity', '0.4');
				$('ul li:nth-child(' + (i + 2) + ')', $sliderBg).css('opacity', '1');

				//Remove all click functions from the bonuses
				$('ul li', $sliderBg).unbind('click');

				//Add click functions to the bonuses next to the middle one.
				$('ul li:nth-child(' + (i + 3) + ')', $sliderBg).click(function () {
					animate('next', true);
				});

				$('ul li:nth-child(' + (i + 1) + ')', $sliderBg).click(function () {
					animate('prev', true);
				});
			}

			function adjust() {
				if (t > ts) {
					t = 0;
				}
				if (t < 0) {
					t = ts;
				}
				$('ul', $sliderBg).css('margin-left', (t * w * -1));
				clickable = true;
				setCurrent(t);
			}

			function animate(dir, clicked) {
				// Check if click was made and switch is neeeded
				if (clickable) {
					clickable = false;
					var ot = t;
					switch (dir) {
						case 'next':
							t = t + 1;
							break;
						case 'prev':
							t = t - 1;
							break;
						case 'first':
							t = 0;
							break;
						case 'last':
							t = ts;
							break;
						default:
							t = dir;
							break;
					}


					//Calculate speed and animate.
					var diff = Math.abs(ot - t);
					var speed = diff * options.speed;
					var p = (t * w * -1);
					$('ul', $sliderBg).animate(
						{ marginLeft: p },
						{ queue: false, duration: speed, complete: adjust }
					);

					//If something is clicked stop the loop
					if (clicked) {
						clearTimeout(timeout);
					}

					//If no click was made and the next dir is called it was made by the loop, so keep animating
					if (dir === 'next' && !clicked) {
						timeout = setTimeout(function() {
							animate('next', false);
						}, diff * options.speed + options.pause);
					}
				}
			}

			// init
			var timeout;
			if (s > 3) {
				timeout = setTimeout(function() {
					animate('next', false);
				}, options.pause);
			}
		});

	};

	$(function() {
		var htmlobject = $('span', '#jackpotvalue');
		var countvalue = 0;
		var endvalue = 417553;
		var steplength = Math.floor(endvalue * 0.005);

		var index = 0;
		var amount = '';

		inloop();

		function inloop() {
			if (countvalue >= (Math.floor(endvalue * 0.9949))) {
				steplength = Math.floor(endvalue * 0.000002);

				if (countvalue >= (endvalue - steplength)) {
					steplength = endvalue - countvalue;
				}
			}

			if (steplength < 1) {
				steplength = 1;
			}
			countvalue += steplength;

			index = countvalue.toString().length;

			for (var i = 0; i < index + 1; i++) {
				amount = countvalue.toString().substr(index - i, 1) + amount;
				if (i % 3 === 0) {
					amount = ' ' + amount;
				}
			}

			htmlobject.html(amount);
			amount = '';

			if (countvalue === endvalue) {
				return;
			}
			if (countvalue >= (Math.floor(endvalue * 0.9949))) {
				setTimeout(inloop, 100);
			} else {
				setTimeout(inloop, 10);
			}
		}
	});
});



